import { Pipe, PipeTransform } from "@angular/core";

//https://stackoverflow.com/questions/36895431/angular2-pipes-how-to-format-a-phone-number

@Pipe({ name: 'summaryNumber' })

export class summaryNumberPipe implements PipeTransform {
	transform(val: string, args: any) {

		//https://codepen.io/rpdasilva/pen/DpbFf
		val = val + '';
		if (!val || !val.trim()) { return ''; }

		var numb = parseFloat(val);
		if (isNaN(numb)) {
			return '';
		}

		if (numb < 1000) {
			return numb;
		} else if (numb < 1000000) {
			return Math.round(numb / 100) / 10 + 'k';
		} else {
			return Math.round(numb / 100000) / 10 + 'm';
		}
	}
}